class FaqSearch {
    constructor(searchInputId, categoryFilterSelector, noResultsMessageSelector, filteredTermsContainerSelector) {
        this.searchInput = document.getElementById(searchInputId);
        this.categoryFilters = Array.from(document.querySelectorAll(categoryFilterSelector));
        this.categoryContainers = Array.from(document.querySelectorAll('.category-container'));
        this.noResultsMessage = document.querySelector(noResultsMessageSelector);
        this.filteredTermsContainer = document.querySelector(filteredTermsContainerSelector);

        this.selectedCategories = new Set(); // Track selected categories as a Set

        this.initSearch();
        this.initCategoryFilters();
    }

    // Initialize search functionality
    initSearch() {
        if (this.searchInput) {
            this.searchInput.addEventListener('input', this.applyFilters.bind(this));
        }
    }

    // Initialize category filter functionality
    initCategoryFilters() {
        this.categoryFilters.forEach(filter => {
            filter.addEventListener('click', (event) => {
                event.preventDefault();

                const categoryId = filter.getAttribute('data-category');

                // Toggle category selection
                if (this.selectedCategories.has(categoryId)) {
                    this.selectedCategories.delete(categoryId); // Deselect if already selected
                    filter.classList.remove('active');
                } else {
                    this.selectedCategories.add(categoryId); // Select new category
                    filter.classList.add('active');
                }

                this.updateFilteredTerms();
                this.applyFilters();
            });
        });
    }

    // Update the filtered search terms display
    updateFilteredTerms() {
        // Clear existing filtered terms
        this.filteredTermsContainer.innerHTML = '';

        // If no categories are selected, clear the container
        if (this.selectedCategories.size === 0) {
            return;
        }

        // Add the header text for filtered terms
        const header = document.createElement('div');
        header.classList.add('filtered-header');
        header.textContent = 'Gefilterte Suchbegriffe:';
        this.filteredTermsContainer.appendChild(header);

        // Add a pill for each selected category
        this.selectedCategories.forEach(categoryId => {
            const categoryFilter = this.categoryFilters.find(filter => filter.getAttribute('data-category') === categoryId);
            const categoryName = categoryFilter ? categoryFilter.textContent : '';

            const pill = document.createElement('span');
            pill.classList.add('filter-term');
            pill.textContent = categoryName;

            // Add a remove button to the pill
            const removeButton = document.createElement('span');
            removeButton.classList.add('remove-filter');
            removeButton.textContent = ' ×';
            removeButton.addEventListener('click', () => {
                this.selectedCategories.delete(categoryId); // Remove category from selection
                categoryFilter.classList.remove('active'); // Unmark the filter button
                this.updateFilteredTerms(); // Update the pills
                this.applyFilters(); // Reapply the filters
            });

            pill.appendChild(removeButton);
            this.filteredTermsContainer.appendChild(pill);
        });
    }

    // Utility function to get category header
    getCategoryHeader(visibleFaqInCategory, categoryTitle) {
        return visibleFaqInCategory > 0
            ? `${visibleFaqInCategory} Treffer zum Thema "${categoryTitle}"`
            : `FAQs zum Thema: <strong>${categoryTitle}</strong>`;
    }

    // Apply filters based on search and selected categories
    applyFilters() {
        const searchQuery = this.searchInput.value.trim().toLowerCase();
        const searchInputGroup = this.searchInput.closest('.faq-search-input-group');
        const activeCategories = Array.from(this.selectedCategories);
        const searchRemoveButton = searchInputGroup.querySelector('.faq-remove-search-button');

        let totalVisibleFaqCount = 0;

        // reset search on click remove search input
        if (searchQuery.length > 0 ) {
            searchRemoveButton.classList.add('show-me');

            searchRemoveButton.addEventListener('click', () => {
                this.searchInput.value = '';
                this.applyFilters();
            });

        } else {
            searchRemoveButton.classList.remove('show-me');
        }

        // Handle categorized FAQs
        const categoryContainers = document.querySelectorAll('.category-container');
        categoryContainers.forEach(container => {
            const categoryTitle = container.getAttribute('data-category');
            const categoryHeader = container.querySelector('h5');
            const faqItems = Array.from(container.querySelectorAll('.accordion-item'));
            let visibleFaqInCategory = 0;

            faqItems.forEach(item => {
                const questionElement = item.querySelector('.accordion-button');
                const answerElement = item.querySelector('.accordion-body');

                const question = questionElement ? questionElement.textContent.toLowerCase() : '';
                const answer = answerElement ? answerElement.textContent.toLowerCase() : '';

                const dataCategory = item.getAttribute('data-category');
                const categories = dataCategory ? dataCategory.split(',') : [];

                const matchesSearch = searchQuery === '' || question.includes(searchQuery) || answer.includes(searchQuery);
                const matchesCategory = activeCategories.length === 0 || activeCategories.includes(categoryTitle);

                if (matchesSearch && matchesCategory) {
                    item.style.display = 'block';
                    visibleFaqInCategory++;
                    totalVisibleFaqCount++;
                } else {
                    item.style.display = 'none';
                }
            });

            // Update the category header dynamically
            const headerText = visibleFaqInCategory > 0
                ? `${visibleFaqInCategory} Treffer zum Thema "${categoryTitle}"`
                : `FAQs zum Thema: <strong>${categoryTitle}</strong>`;

            // If no search query or categories, always reset to original header
            categoryHeader.innerHTML = searchQuery === '' && activeCategories.length === 0
                ? `FAQs zum Thema: <strong>${categoryTitle}</strong>`
                : headerText;

            container.style.display = visibleFaqInCategory > 0 ? 'block' : 'none';
        });

        // Handle non-categorized FAQs with the same logic
        const nonCategorizedFaqItems = document.querySelectorAll('.non-categorized-item');
        nonCategorizedFaqItems.forEach(item => {
            const questionElement = item.querySelector('.accordion-button');
            const answerElement = item.querySelector('.accordion-body');

            const question = questionElement ? questionElement.textContent.toLowerCase() : '';
            const answer = answerElement ? answerElement.textContent.toLowerCase() : '';

            const dataCategory = item.getAttribute('data-category');
            const categories = dataCategory ? dataCategory.split(',') : [];

            const matchesSearch = searchQuery === '' || question.includes(searchQuery) || answer.includes(searchQuery);
            const matchesCategory = activeCategories.length === 0 || activeCategories.some(cat => categories.includes(cat));

            if (matchesSearch && matchesCategory) {
                item.style.display = 'block';
                totalVisibleFaqCount++;
            } else {
                item.style.display = 'none';
            }
        });

        // Show or hide the "No Results" message
        if (this.noResultsMessage) {
            this.noResultsMessage.style.display = totalVisibleFaqCount === 0 ? 'block' : 'none';
        }
    }

}

// Initialize the FAQ search functionality
new FaqSearch(
    'faqSearchInput',         // Search input ID
    '.faq-filter',            // Category filter selector
    '#no-results',            // "No Results" message selector
    '.filtered-search-terms'  // Filtered search terms container
);
